export class AzureFilesBackupPolicyPlan {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupSchedules",
            "baseName": "backupSchedules",
            "type": "Array<AzureFilesBackupSchedules>",
            "format": ""
        },
        {
            "name": "storageRedundancy",
            "baseName": "storageRedundancy",
            "type": "AzureFilesBackupPolicyPlanStorageRedundancyEnum",
            "format": ""
        },
        {
            "name": "enableCrossRegionRestore",
            "baseName": "enableCrossRegionRestore",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "scheduleMode",
            "baseName": "scheduleMode",
            "type": "AzureFilesBackupPolicyPlanScheduleModeEnum",
            "format": ""
        },
        {
            "name": "hourlyIntervalHours",
            "baseName": "hourlyIntervalHours",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "storageAccountSelections",
            "baseName": "storageAccountSelections",
            "type": "Array<AzureFilesStorageAccountSelection>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureFilesBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
export var AzureFilesBackupPolicyPlanStorageRedundancyEnum;
(function (AzureFilesBackupPolicyPlanStorageRedundancyEnum) {
    AzureFilesBackupPolicyPlanStorageRedundancyEnum["Lrs"] = "LRS";
    AzureFilesBackupPolicyPlanStorageRedundancyEnum["Zrs"] = "ZRS";
    AzureFilesBackupPolicyPlanStorageRedundancyEnum["Grs"] = "GRS";
})(AzureFilesBackupPolicyPlanStorageRedundancyEnum || (AzureFilesBackupPolicyPlanStorageRedundancyEnum = {}));
export var AzureFilesBackupPolicyPlanScheduleModeEnum;
(function (AzureFilesBackupPolicyPlanScheduleModeEnum) {
    AzureFilesBackupPolicyPlanScheduleModeEnum["Daily"] = "DAILY";
    AzureFilesBackupPolicyPlanScheduleModeEnum["Hourly"] = "HOURLY";
})(AzureFilesBackupPolicyPlanScheduleModeEnum || (AzureFilesBackupPolicyPlanScheduleModeEnum = {}));
